export default "__VITE_ASSET__DuRTGD52__"